import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { userInfo } = useAuth();

  if (!userInfo) return <Navigate to="/login" />;
  if (adminOnly && !userInfo.isAdmin) return <Navigate to="/" />;

  return children;
};

export default ProtectedRoute;